// extracted by mini-css-extract-plugin
export default {"file-uploader-icon":"file-uploader-icon_file-uploader-icon__eUjcr"};